import { motion } from "framer-motion";
import { Button } from "react-bootstrap";
import styled, { keyframes } from "styled-components";

// Styled Components
export const SecondaryContainer = styled.div`
  padding-top: 5rem;

  @media (min-width: 1024px) {
    padding-top: 0rem;
  }
`;

export const Header = styled(motion.h1)`
  color: #111827;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  line-height: 1.25;

  @media (min-width: 768px) {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  @media (min-width: 1024px) {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  @media (min-width: 1280px) {
    font-size: 3rem;
    line-height: 1.2;
  }
`;

export const Description = styled.p`
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  font-size: 1rem;
  line-height: 1.5rem;

  @media (min-width: 1024px) {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  @media (min-width: 1280px) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

export const PrimaryButton = styled(Button)`
  display: inline-block;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;

  @media (min-width: 640px) {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;

export const TextContainer = styled.div`
  text-align: center;

  @media (min-width: 1024px) {
    text-align: left;
  }
`;

export const SubHeading = styled.h5`
  font-weight: 700;
`;
